import { render, staticRenderFns } from "./PurchaseUnitPrice.vue?vue&type=template&id=e88cfc26&"
import script from "./PurchaseUnitPrice.vue?vue&type=script&lang=js&"
export * from "./PurchaseUnitPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports